import { motion } from "framer-motion";
import React, {useEffect, useState} from "react";
import Transition from "../components/Transition";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import {useNavigate} from "react-router-dom";
import {scroller} from "react-scroll";
import Pic1 from "../assets/images/businessman-waiting-bottom-private-jet-stairs-dusk-businessman-standing-wet-tarmac-bottom-private-jet-stairs-371098277.png";
import Pic2 from "../assets/images/gettyimages-200514552-001-1024x1024_upscayl_3x_realesrgan-x4plus.webp";
import Pic3 from "../assets/images/ChatGPT Image 7 août 2025, 18_15_30.png";
import Pic4 from "../assets/images/ChatGPT Image 7 août 2025, 18_08_21.png";
import {FaArrowRight} from "react-icons/fa";
import PicRow1 from "../assets/images/rapide.png";
import PicRow2 from "../assets/images/appel-telephonique.png";
import PicRow3 from "../assets/images/bouclier.png";
import ServicesJson from "../assets/jsons/services.json";
import TestimonialsJson from "../assets/jsons/testimonials.json";
import GlobalJson from "../assets/jsons/Global.json";
import WhyAvantyJson from "../assets/jsons/whyavanty.json";

const GOLD = "#C1A45F";

const services = [
    {
        title: "Réactivité absolue",
        desc: "Nous répondons et organisons en quelques minutes, 24/7.",
        img: PicRow1,
    },
    {
        title: "Disponibilité sur-mesure",
        desc: "Un interlocuteur unique, présent à chaque étape.",
        img: PicRow2,
    },
    {
        title: "Discrétion & sécurité",
        desc: "Standards premium de sécurité et confidentialité.",
        img: PicRow3,
    },
];

const testimonials = [
    {
        name: "Lucien D.",
        role: "Dirigeant",
        quote:
            "Avanty Jet a transformé un déplacement banal en un moment d’exception. Discrétion, précision, excellence.",
    },
    {
        name: "Élodie S.",
        role: "Influenceuse voyage",
        quote:
            "Jamais je n’avais vécu un service aussi personnalisé — du sur-mesure à l’état pur.",
    },
];

function SectionTitle({ eyebrow, title, subtitle }) {
    return (
        <div className="text-center">
            {eyebrow && <p className="uppercase text-sm tracking-widest text-white/60 mb-2">{eyebrow}</p>}
            <h2 className="text-3xl sm:text-4xl font-extrabold" style={{ color: GOLD }}>{title}</h2>
            {subtitle && <p className="mt-3 text-white/80 max-w-4xl mx-auto">{subtitle}</p>}
        </div>
    );
}

function ImageCarousel({ images }) {
    const [index, setIndex] = useState(0);
    useEffect(() => {
        const t = setInterval(() => setIndex((i) => (i + 1) % images.length), 4500);
        return () => clearInterval(t);
    }, [images.length]);
    return (
        <div className="relative w-full rounded-2xl overflow-hidden shadow-xl">
            <img src={images[index]} alt={`carousel-${index}`} className="w-full h-96 object-cover" />
            <div className="absolute bottom-4 left-4 flex gap-2">
                {images.map((_, i) => (
                    <button
                        key={i}
                        onClick={() => setIndex(i)}
                        className={`w-10 h-2 rounded-full ${i === index ? "bg-white" : "bg-white/40"}`}
                    />
                ))}
            </div>
        </div>
    );
}

function DemanderDevisButton({language}) {
    const navigate = useNavigate();

    return (
        <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }} className="flex justify-center cursor-pointer">
            <a
                onClick={() => navigate("/#quotation")}
                className="px-10 py-4 rounded-full bg-white text-black font-semibold shadow-lg flex items-center hover:bg-gray-100 transition"
            >
                {GlobalJson.availableLanguages[language].ctaButton}
                <FaArrowRight className="ml-2" />
            </a>
        </motion.div>
    );
}

export default function MainContent({ language, setLanguage }) {
    const navigate = useNavigate();
    const sections = [
        {
            title: "Origines",
            paragraphs: [
                "Il existe des entreprises qui naissent par nécessité. Avanty Jet est née d’une conviction profonde : celle que le voyage privé pouvait devenir une œuvre d’art.",
                "Dès ses origines, Avanty Jet a refusé l’idée d’une aviation privée standardisée, fonctionnelle mais sans âme. Nous avons rêvé d’un service qui ne se contente pas de transporter, mais qui inspire, qui émeut, qui honore la noblesse du déplacement.",
                "Ce rêve est né à la croisée de deux passions : celle du ciel et de l’aviation, dans toute sa beauté technique et émotionnelle, et celle du service sur-mesure, porté à son plus haut niveau, à l’image des grandes maisons françaises de tradition.",
                "Fondée par des professionnels exigeants, passionnés d’aviation d’affaires, Avanty Jet est rapidement devenue plus qu’un simple courtier : une Maison du Voyage, où chaque vol est dessiné comme une création unique, façonnée autour de la personnalité de son passager.",
                "Notre nom — Avanty — traduit cet esprit d’élan, de mouvement maîtrisé, d’audace élégante. 'The Art of Moving Forward' est bien plus qu’une signature : c’est notre philosophie de chaque instant.",
                "Aujourd'hui, Avanty Jet accompagne chefs d’entreprise, entrepreneurs, familles et personnalités du monde entier avec une promesse simple et sincère : offrir non seulement un service irréprochable, mais surtout un art de vivre, une nouvelle façon d’habiter le ciel."
            ]
        },
        {
            title: "Sur-Mesure",
            paragraphs: [
                "Chez Avanty Jet, chaque client est considéré comme un hôte d’honneur. Chaque détail est anticipé, chaque préférence enregistrée, chaque demande traitée comme une évidence.",
                "Dès votre première prise de contact, un gestionnaire de vol privé personnel vous est assigné. Il devient le gardien discret de votre expérience, disponible sans interruption, coordonnant avec une précision horlogère l'ensemble des étapes de votre voyage :"
            ],
            list: [
                "Sélection de l'appareil idéal.",
                "Création de l'itinéraire optimal.",
                "Prise en charge des prestations de conciergerie.",
                "Adaptation aux imprévus avec la plus grande fluidité."
            ],
            closing: ["Aucun formulaire impersonnel, aucune attente. Seulement l’écoute, l’intelligence de situation, et la volonté farouche de vous offrir une expérience parfaite."]
        },
        {
            title: "Sécurité",
            paragraphs: [
                "L’excellence du service commence par une exigence absolue sur la sécurité et la qualité technique. Avanty Jet travaille uniquement avec un cercle restreint d’opérateurs triés sur le volet, tous certifiés selon les normes aéronautiques internationales les plus strictes :"
            ],
            list: [
                "Certification EASA OPS pour l’Europe.",
                "Certification ARGUS Platinium pour l’Amérique du Nord.",
                "Certification Wyvern Wingman pour les standards internationaux."
            ],
            closing: [
                "Chaque opérateur est évalué non seulement sur ses normes officielles, mais aussi sur des critères internes propres à Avanty Jet :",
                "Maintenance des appareils, formation continue des équipages, respect rigoureux des standards de confidentialité et d’excellence du service.",
                "Chaque vol affrété par Avanty Jet est ainsi l’assurance d’un voyage placé sous le signe de la confiance, du confort, et de la sérénité la plus totale."
            ]
        },
        {
            title: "Élégance",
            paragraphs: [
                "Chez Avanty Jet, nous portons haut l'héritage d'un art de vivre façonné par la tradition française : celui où chaque détail est pensé, anticipé, magnifié pour rendre l'expérience inoubliable sans jamais l'imposer.",
                "Notre philosophie repose sur une conviction : aucun client ne ressemble à un autre, aucun voyage ne peut être standardisé, aucun service ne doit être générique. Chaque mission est une création unique."
            ],
            list: [
                "Avant même votre vol, votre gestionnaire privé recueille vos préférences précises : vos boissons favorites, votre traiteur attitré, votre playlist idéale pour le vol, vos besoins spécifiques en confort ou en confidentialité.",
                "Le jour de votre voyage, tout est préparé pour refléter votre univers : votre cabine est ajustée à votre température idéale, vos lectures préférées sont disponibles, vos goûts culinaires sont respectés jusque dans les moindres détails.",
                "Même les équipages sont briefés avec finesse : un ton plus formel ou plus amical selon votre profil, un accueil en toute discrétion ou une attention chaleureuse selon votre humeur.",
                "Sur demande, nous orchestrons aussi des expériences uniques : réception privée à l'aéroport, accès direct au pied de l'appareil, service de limousine adaptée à vos envies, survol panoramique avant l'atterrissage si vous le souhaitez."
            ],
            closing: [
                "Tout est pensé pour que votre vol devienne une extension naturelle de votre style de vie et non une simple parenthèse."
            ]
        },
    ];
    const paragraphs = [
        "Avanty Jet, c’est l’art d’offrir une expérience profondément personnelle, naturellement harmonieuse, délicatement orchestrée sans jamais forcer, sans jamais répéter.",
        "Chaque détail a du sens. À bord d'Avanty Jet, ce n'est pas vous qui vous adaptez à l'appareil : c'est l'appareil qui s'adapte à vous."
    ]

    useEffect(() => {
        if (window.location.hash === "#test") {
            setTimeout(() => {
                scroller.scrollTo("test", {
                    smooth: true,
                    duration: 600,
                    offset: -110,
                });
            }, 100);
        }

        if (window.location.hash === "#test2") {
            setTimeout(() => {
                scroller.scrollTo("test2", {
                    smooth: true,
                    duration: 600,
                    offset: -110,
                });
            }, 100);
        }

        if (window.location.hash === "#test3") {
            setTimeout(() => {
                scroller.scrollTo("test3", {
                    smooth: true,
                    duration: 600,
                    offset: -110,
                });
            }, 100);
        }

        if (window.location.hash === "#test4") {
            setTimeout(() => {
                scroller.scrollTo("test4", {
                    smooth: true,
                    duration: 600,
                    offset: -110,
                });
            }, 100);
        }
    }, [window.location.hash]);

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.7 }}
            className="flex-1 z-10"
        >
            <div className="relative z-20">
                <Navbar language={language} setLanguage={setLanguage} />
            </div>

            <div className="bg-myDarkBlue w-full flex flex-col items-center relative z-[1]">
                <div className="w-full max-w-screen-xl px-6 sm:px-10 pt-32 pb-16 space-y-32">
                    {/* Hero Section */}
                    <section className="w-full max-w-7xl mx-auto px-6 sm:px-10 pt-32 pb-10 text-center">
                        <motion.h1
                            initial={{ opacity: 0, y: 30 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.6 }}
                            className="text-5xl sm:text-6xl font-extrabold tracking-tight leading-tight"
                        >
                            {WhyAvantyJson.availableLanguages[language].Title} <span className="text-[#C1A45F] hyphens-auto">{WhyAvantyJson.availableLanguages[language].Title2}</span>
                        </motion.h1>
                        <p className="mt-6 text-lg sm:text-xl text-white/70 max-w-3xl mx-auto">
                            {WhyAvantyJson.availableLanguages[language].Intro}
                        </p>
                    </section>

                    <motion.div
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6 }}
                        className="px-4"
                    >
                        <ul className="space-y-4 text-lg font-light tracking-wide max-w-3xl px-14">
                            {[
                                { text: WhyAvantyJson.availableLanguages[language].Sections.History, link: "#test" },
                                { text: WhyAvantyJson.availableLanguages[language].Sections.Service, link: "#test2" },
                                { text: WhyAvantyJson.availableLanguages[language].Sections.Network, link: "#test3" },
                                { text: WhyAvantyJson.availableLanguages[language].Sections.ArtOfLiving, link: "#test4" },
                            ].map((item, index) => (
                                <motion.li
                                    key={index}
                                    initial={{ opacity: 0, x: -20 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    viewport={{ once: true }}
                                    transition={{ duration: 0.5, delay: index * 0.15 }}
                                    className="cursor-pointer relative group"
                                    onClick={() => navigate(item.link)}
                                >
                                            <span className="transition-colors duration-300 group-hover:text-[#C1A45F] text-[#C1A45F]">
          •
        </span>
        <span className="transition-colors duration-300 group-hover:text-[#C1A45F] ml-2">
          {item.text}
        </span>
                                    <span className="absolute left-0 bottom-0 w-0 h-[1px] bg-[#C1A45F] transition-all duration-300 group-hover:w-full"></span>
                                </motion.li>
                            ))}
                        </ul>
                    </motion.div>

                    {/* Section Argumentaire */}
                    <section className="w-full max-w-6xl mx-auto px-6 sm:px-10 space-y-28 mb-32">
                        {WhyAvantyJson.availableLanguages[language].sections.map((section, idx) => (
                            <motion.div
                                key={idx}
                                initial={{ opacity: 0, y: 40 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.3, delay: (idx + 0.2) * 0.15 }}
                                className="grid sm:grid-cols-12 gap-8 items-start"
                                id={idx === 0 ? "test" : idx === 1 ? "test2" : idx === 2 ? "test3" : "test4"}
                            >
                                <div className="sm:col-span-4">
                                    <h2 className="text-2xl sm:text-3xl font-semibold text-[#C1A45F] border-b-4 border-[#C1A45F] pb-2">
                                        {section.title}
                                    </h2>
                                    <img src={idx == 0 ? Pic1 : idx == 1 ? Pic4 : idx == 2 ? Pic2 : Pic3} alt="Avanty Jet" className="mt-4 rounded-lg shadow-lg w-full h-[500px] object-cover" />
                                </div>
                                <div className="sm:col-span-8 space-y-4 text-white/90 text-base sm:text-lg leading-relaxed">
                                    {section.paragraphs.map((p, i) => (
                                        <p key={`p-${i}`}>{p}</p>
                                    ))}
                                    {section.list && (
                                        <ul className="list-disc list-inside space-y-2 mt-3">
                                            {section.list.map((item, i) => (
                                                <li key={`li-${i}`}>{item}</li>
                                            ))}
                                        </ul>
                                    )}
                                    {section.closing?.map((c, i) => (
                                        <p key={`c-${i}`} className="mt-3 italic">{c}</p>
                                    ))}
                                </div>
                            </motion.div>
                        ))}
                    </section>

                    <div className={"text-center"}>
                        <p>{WhyAvantyJson.availableLanguages[language].heroTitle1}</p>
                        <p>{WhyAvantyJson.availableLanguages[language].heroTitle2}</p>
                    </div>

                    {/*/!* Esprit AvantyJet *!/*/}
                    {/*<section className="text-center mb-32 px-6 sm:px-10">*/}
                    {/*    <motion.div*/}
                    {/*        initial={{ opacity: 0 }}*/}
                    {/*        whileInView={{ opacity: 1 }}*/}
                    {/*        viewport={{ once: true }}*/}
                    {/*        transition={{ duration: 0.5 }}*/}
                    {/*    >*/}
                    {/*        <p className="text-xl sm:text-2xl font-light tracking-wider text-white/70">L'esprit</p>*/}
                    {/*        <h2 className="text-4xl sm:text-6xl font-bold border-b-4 border-[#C1A45F] inline-block mt-2 pb-3">*/}
                    {/*            AVANTYJET*/}
                    {/*        </h2>*/}
                    {/*    </motion.div>*/}

                    {/*    <div className="mt-16 grid grid-cols-1 sm:grid-cols-3 gap-10 max-w-3xl mx-auto">*/}
                    {/*        {[{ img: Picrowadvantages1, label: "Réactivité" },*/}
                    {/*            { img: Picrowadvantages2, label: "Disponibilité" },*/}
                    {/*            { img: Picrowadvantages3, label: "Sécurité" }].map(({ img, label }, i) => (*/}
                    {/*            <motion.div*/}
                    {/*                key={i}*/}
                    {/*                whileHover={{ scale: 1.05 }}*/}
                    {/*                transition={{ type: "spring", stiffness: 250 }}*/}
                    {/*                className="flex flex-col items-center text-center"*/}
                    {/*            >*/}
                    {/*                <img src={img} alt={label} className="w-24 h-24" />*/}
                    {/*                <p className="text-xl font-medium mt-4">{label}</p>*/}
                    {/*            </motion.div>*/}
                    {/*        ))}*/}
                    {/*    </div>*/}
                    {/*</section>*/}

                    {/*/!* CTA *!/*/}
                    {/*<section className="relative w-full px-10 sm:px-10 pb-32">*/}
                    {/*    <motion.div*/}
                    {/*        initial={{ opacity: 0, y: 40 }}*/}
                    {/*        whileInView={{ opacity: 1, y: 0 }}*/}
                    {/*        viewport={{ once: true }}*/}
                    {/*        transition={{ duration: 0.5 }}*/}
                    {/*        className="max-w-4xl mx-auto text-center"*/}
                    {/*    >*/}
                    {/*        <p className="text-4xl sm:text-6xl font-extrabold leading-tight">*/}
                    {/*            <span className="block mb-2 text-[#C1A45F]">Prêt à décoller ?</span>*/}
                    {/*            Votre vol privé vous attend.*/}
                    {/*        </p>*/}

                    {/*        <div className="mt-10">*/}
                    {/*            <a*/}
                    {/*                href="/#quotation"*/}
                    {/*                className="inline-block px-8 py-4 rounded-full bg-[#C1A45F] text-black font-semibold text-lg hover:bg-white transition-all duration-300 shadow-lg hover:shadow-amber-400/50"*/}
                    {/*            >*/}
                    {/*                Demander un devis*/}
                    {/*            </a>*/}
                    {/*        </div>*/}
                    {/*    </motion.div>*/}
                    {/*</section>*/}

                </div>
            </div>
            {/* BRAND PROMISE */}
            <section className="pt-28 pb-16 bg-gradient-to-b from-myDarkBlue via-[#0f172a] to-myDarkBlue">
                <div className="max-w-7xl mx-auto px-6">
                    <SectionTitle
                        eyebrow={ServicesJson.availableLanguages[language].title1}
                        title={ServicesJson.availableLanguages[language].title2}
                        subtitle={ServicesJson.availableLanguages[language].title3}
                    />

                    <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
                        {services.map((s, i) => (
                            <motion.div
                                key={i}
                                whileHover={{y: -6}}
                                className="p-6 rounded-2xl bg-black/20 border border-white/20 shadow-lg"
                                style={{
                                    boxShadow: `
    0 -6px 10px rgba(255, 255, 255, 0.1),
    0 -8px 20px rgba(255, 255, 255, 0.05)
  `
                                }}
                            >
                                <div className="flex items-center gap-4">
                                    <img src={s.img} alt={s.title} className="w-16 h-16"/>
                                    <div>
                                        <h4 className="text-xl font-semibold text-white">{ServicesJson.availableLanguages[language].services[i].title}</h4>
                                        <p className="text-white/75 mt-1">{ServicesJson.availableLanguages[language].services[i].desc}</p>
                                    </div>
                                </div>
                                <div className="mt-6 text-sm text-white/60 flex justify-center">
                                    {ServicesJson.availableLanguages[language].services[i].bottom}
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>

            {/* TESTIMONIALS */}
            <section className="py-16 bg-myDarkBlue">
                <div className="max-w-7xl mx-auto px-6 text-center">
                    <SectionTitle eyebrow={TestimonialsJson.availableLanguages[language].title}
                                  title={TestimonialsJson.availableLanguages[language].subtitle}/>

                    <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6">
                        {testimonials.map((t, i) => (
                            <motion.div
                                key={i}
                                initial={{opacity: 0, y: 20}}
                                whileInView={{opacity: 1, y: 0}}
                                whileHover={{y: -6}}
                                viewport={{once: true}}
                                className="relative p-6 rounded-2xl bg-black/20 border border-white/10 overflow-hidden bg-[radial-gradient(circle_at_center,rgba(255,255,255,0.05),transparent_70%)]"
                                style={{
                                    boxShadow: `
    0 -6px 10px rgba(255, 255, 255, 0.1),
    0 -8px 20px rgba(255, 255, 255, 0.05)
  `
                                }}
                            >
                                <div
                                    className="absolute -top-4 left-0 w-full h-4 pointer-events-none"
                                    style={{
                                        boxShadow: "0 0 10px 2px rgba(255, 255, 255, 0.2)",
                                        maskImage: "linear-gradient(to bottom, white, transparent)",
                                        WebkitMaskImage: "linear-gradient(to bottom, white, transparent)"
                                    }}
                                />

                                <p className="italic text-white/80">{TestimonialsJson.availableLanguages[language].testimonials[i].quote}</p>
                                <p className="mt-4 font-semibold text-white">{TestimonialsJson.availableLanguages[language].testimonials[i].author}</p>
                                <p className="text-sm text-white/60">{TestimonialsJson.availableLanguages[language].testimonials[i].role}</p>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>

            {/* FINAL CTA */}
            <section className="pt-10 pb-32 bg-myDarkBlue text-center">
                <h2 className="text-4xl font-extrabold mb-4"
                    style={{color: GOLD}}>{GlobalJson.availableLanguages[language].ctaTitle}</h2>
                <p className="text-white/80 max-w-2xl mx-auto mb-8">{GlobalJson.availableLanguages[language].contact}</p>
                <div className="flex items-center justify-center gap-4">
                    <DemanderDevisButton language={language}/>
                </div>
            </section>
            <Footer language={language} />
        </motion.div>
    );

}

export function WhyAvanty({language, setLanguage}) {
    const [isTransitionVisible, setIsTransitionVisible] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsTransitionVisible(false);
        }, 800);

        return () => clearTimeout(timer);
    }, []);

    return (
        <div>
            {isTransitionVisible ? (
                <Transition/>
            ) : (
                <MainContent language={language} setLanguage={setLanguage}/>
            )}
        </div>
    );
}